export const getYoutubeVideoId = (url) => {
  const regExp = /(?:\/embed\/|\/v\/|\/watch\?v=|youtu\.be\/|\/shorts\/)([a-zA-Z0-9_-]+)/
  const match = url.match(regExp)

  return match && match[1].length === 11 ? match[1] : false
}

export const isDesktop = () => $(window).outerWidth() > 1199.9
